import { Program } from '@4tn/tv-npm-player'
import { GRADIENT_BACKGROUND, TRANSLATIONS } from '../constants'
import { BLUR_PREFIX } from './adBlockDetection'
import { isAndroidChrome } from './device'
import featureTooling, { FEATURES } from './featureTooling'
import { trackClick } from './tealium'

const DEFAULT_BACKGROUND = 'https://kijk.nl/static/images/default_editorial_landscape.png'

export default function styleError({
  error,
  item,
  drmSupported,
}: {
  error: any
  item?: Program
  drmSupported: boolean
}): void {
  const errorContainer = document.querySelector<HTMLDivElement>('.jw-error')
  const errorMessage = document.querySelector<HTMLDivElement>('.jw-error .jw-error-msg')
  if (!errorContainer || !errorMessage) return

  // hide default info and icon
  document.querySelectorAll<HTMLDivElement>('.jw-error .jw-icon, .jw-error .jw-info-container').forEach((elem) => {
    elem.style.display = 'none'
  })

  if (!drmSupported && featureTooling.isFeatureEnabled(FEATURES.DRM_MESSAGE) && isAndroidChrome()) {
    Object.assign(errorContainer.style, {
      backgroundImage: `url(${GRADIENT_BACKGROUND})`,
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      display: 'grid',
    })

    const drmMessage = document.createElement('img')
    Object.assign(drmMessage, {
      src: 'https://static.kijk.nl/images/drm-message.png',
      alt: TRANSLATIONS.SOMETHING_WENT_WRONG,
    })
    Object.assign(drmMessage.style, {
      margin: 'auto',
      maxWidth: '500px',
      objectFit: 'contain',
      width: '100%',
      maxHeight: '300px',
    })
    errorContainer.append(drmMessage)
    errorMessage.remove()
    return
  }

  Object.assign(errorContainer.style, {
    backgroundImage: `url(${BLUR_PREFIX}/${item?.image || DEFAULT_BACKGROUND})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  })

  const image = document.createElement('img')
  Object.assign(image, {
    src: 'https://static.kijk.nl/images/broken-tv.png',
    alt: TRANSLATIONS.SOMETHING_WENT_WRONG,
  })

  const errorInfo = document.createElement('p')
  errorInfo.innerText = drmSupported === false ? TRANSLATIONS.DEVICE_NOT_SUPPORTED : TRANSLATIONS.SOMETHING_WENT_WRONG

  if (error.code) {
    errorInfo.innerText += `\nFoutcode: ${error.code}`
  }

  Object.assign(errorMessage.style, {
    flexDirection: 'column',
    backgroundColor: '#00000000',
    height: `100vh`,
    width: '100vw',
    padding: '10',
    alignItems: 'center',
    justifyContent: 'center',
  })

  errorMessage.prepend(image, errorInfo)

  if (item) {
    const reloadButton = document.createElement('button')
    Object.assign(reloadButton, {
      className: 'btn',
      innerText: TRANSLATIONS.WATCH_VIDEO,
      onclick: () => {
        trackClick(TRANSLATIONS.WATCH_VIDEO)
        window.open(`https://www.kijk.nl/video/${item.guid}`, '_blank')
      },
    })
    errorMessage.append(reloadButton)
  }
}
